export const appConfig = 
// @ts-ignore
typeof window !== 'undefined' && window.__app_config ? window.__app_config : {};
